import { cn } from 'lib/utils';
import { useTheme } from 'components/core/theme-provider';

type AuthDividerProps = Readonly<{
  text: string;
  variant?: 'default' | 'klax';
  className?: string;
}>;

export function AuthDivider({ text, variant = 'default', className }: AuthDividerProps) {
  const { resolvedTheme } = useTheme();
  const isKlax = variant === 'klax';
  const isDark = resolvedTheme === 'dark';

  if (isKlax) {
    const gradientColor = isDark ? '#ffffff' : '#d1d1d1';

    return (
      <div className={cn('flex items-center gap-5', className)}>
        <div
          className="h-px min-w-px flex-1"
          style={{
            background: `linear-gradient(to left, ${gradientColor}, transparent)`
          }}
          aria-hidden
        />
        <span className={cn(
          'shrink-0 text-center text-base font-medium leading-[1.2]',
          isDark ? 'text-true-white' : 'text-black'
        )}>
          {text}
        </span>
        <div
          className="h-px min-w-px flex-1"
          style={{
            background: `linear-gradient(to right, ${gradientColor}, transparent)`
          }}
          aria-hidden
        />
      </div>
    );
  }

  return (
    <div className={cn('mb-4 flex items-center gap-4', className)}>
      <div className="flex-1">
        <hr className="h-[2px] rounded border-0 bg-gray-200" />
      </div>
      <div className="shrink-0 text-base font-normal leading-[1.2] text-low-emphasis">{text}</div>
      <div className="flex-1">
        <hr className="h-[2px] rounded border-0 bg-gray-200" />
      </div>
    </div>
  );
}
